import styled from 'styled-components';
import { Container, Segment } from 'semantic-ui-react';

export const SemanticContainer = styled(Container)`
  padding: 1rem 0 0 250px;
  
`;

export const SemanticSegment = styled(Segment)`
  text-align: center;
  position: relative;
  bottom: 0;
`;

